import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface IState {
  isImporting: boolean;
}

interface IActions {
  setIsImporting: (value: boolean) => void;
  reset: () => void;
}

const initState: IState = {
  isImporting: false,
};

export const useMediaLibImportStore = create<IState & IActions>((set) => ({
  ...initState,
  setIsImporting: (isImporting) => set({ isImporting }),
  reset: () => set(initState),
}));

export const useMediaLibImportStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useMediaLibImportStore(useShallow(selector));
};
